/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { Form } from "grab-ui"
import { Select } from "@duxton-web/ui"
import { BULK_UPLOAD_EXPORT_FILE_FIELDS } from "constants/menu_bulk_upload"
import { useTranslations } from "common/utils/i18n"
import { ExportInventoryItemStatus } from "types/delv-platform-api/inventoryCategory"

const selectCss = css`
  width: 100%;
`

const InventoryItemStatusSelect = ({ form }: FormComponentProps) => {
  const { getFieldDecorator } = form
  const itemStatusTexts = useTranslations(
    Object.keys(ExportInventoryItemStatus).map(
      key => `bulkUpload.drawers.downloadInventory.itemStatus.${key}`,
    ),
  )

  return (
    <Form.Item>
      {getFieldDecorator(BULK_UPLOAD_EXPORT_FILE_FIELDS.categoryItemStatus, {
        initialValue: ExportInventoryItemStatus.All,
      })(
        <Select css={selectCss}>
          {Object.keys(ExportInventoryItemStatus).map(
            (key: keyof typeof ExportInventoryItemStatus, index) => {
              const itemStatus = ExportInventoryItemStatus[key]
              return (
                <Select.Option key={itemStatus} value={itemStatus}>
                  <div>{itemStatusTexts[index]}</div>
                </Select.Option>
              )
            },
          )}
        </Select>,
      )}
    </Form.Item>
  )
}

export default InventoryItemStatusSelect
